// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-fields-container {
    max-height: 332px;
    overflow: auto;
    padding: 2px;
}

.user-fields-list {
    margin: 16px 0;
}

.user-fields-dialog-content {
    width: 408px;
    max-height: 491px;
}

.user-fields-dialog-content .field-label {
    color: var(--theia-editorWidget-foreground);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.01em;
    text-align: left;
}

.user-fields-dialog-content .theia-input {
    flex-grow: 1;
}

.user-fields-dialog-content .button-container {
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/user-fields-dialog.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".user-fields-container {\r\n    max-height: 332px;\r\n    overflow: auto;\r\n    padding: 2px;\r\n}\r\n\r\n.user-fields-list {\r\n    margin: 16px 0;\r\n}\r\n\r\n.user-fields-dialog-content {\r\n    width: 408px;\r\n    max-height: 491px;\r\n}\r\n\r\n.user-fields-dialog-content .field-label {\r\n    color: var(--theia-editorWidget-foreground);\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 21px;\r\n    letter-spacing: 0.01em;\r\n    text-align: left;\r\n}\r\n\r\n.user-fields-dialog-content .theia-input {\r\n    flex-grow: 1;\r\n}\r\n\r\n.user-fields-dialog-content .button-container {\r\n    justify-content: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
